import React from 'react';

export const W9OnFileDisplay: React.FC = () => {
    return (
        <>
            <h2 className='decorated'>W9 File</h2>
            <p>
                We have a W9 on file for you. If it needs to be updated, please email an
                updated W9 separately.
            </p>
        </>
    );
};
